import { TicketRateLine } from '../generated/graphql';

const getTicketGroupText = (rateLines: TicketRateLine[]) =>
    `${rateLines.reduce((total, next) => total + next.amount, 0)} tickets`;

export default getTicketGroupText;
